import {ChangeDetectionStrategy, Component, ViewChild} from '@angular/core';
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

declare interface DropdownItem {
  readonly id: string;
  readonly name: string;
  readonly url: string;
}

@Component({
  selector: 'asax-header-help-container',
  templateUrl: './help-container.component.html',
  styles:
  [
    `.dropdown-toggle::after {
      display: none;
    }`
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpContainerComponent {
  readonly dropdownItems: DropdownItem[] = [
    {
      id: 'archive-manual',
      name: 'Archive Manual',
      url: 'https://almascience.org/documents-and-tools/latest/science-archive-manual'
    },
    {
      id: 'archive-notebooks',
      name: 'Archive Notebooks',
      url: 'https://almascience.eso.org/alma-data/archive/archive-notebooks'
    },
    {
      id: 'archive-video',
      name: 'Archive Video Tutorials',
      url: 'https://almascience.eso.org/documents-and-tools/latest/archive-primer'
    },
    {
      id: 'archive-primer',
      name: 'Archive Data Primer',
      url: 'https://almascience.eso.org/alma-data/archive/archive-video-tutorials'
    },
    {
      id: 'archive-documentation',
      name: 'Archive Documentation',
      url: 'https://almascience.eso.org/alma-data/archive/archive-documentation'
    }
  ]

  openNewTab(url: string): void {
    window.open(url, '_blank');
  }
}
